import { lazy } from 'react';

const RejectedCertificationVerifierConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verifier/consult/rejected-certification',
			component: lazy(() => import('./RejectedCertificationContainer'))
		}
	]
};

export default RejectedCertificationVerifierConfig;



